export default "__VITE_ASSET__14c84bdd__"